module.exports = __webpack_public_path__ + "static/media/wish_III_cs.034e7a55.png";